import {useLazyQuery} from '@apollo/react-hooks';
import {shallowEqual, useSelector} from 'react-redux';
import getStoreData from './selectors';
import GET_UAS_USER_ACTIVITY from './queries/uas.gql';

const useUserActivityData = () => {
    const {currency} = useSelector(getStoreData, shallowEqual);

    const [getUASUserActivity, uas] = useLazyQuery(GET_UAS_USER_ACTIVITY, {
        variables: {
            currency,
        },
        errorPolicy: 'ignore',
        ssr: false,
    });

    const called = uas.called;
    const data = uas.data?.userActivity;
    const completed = called && !uas.loading;
    const loading = called && uas.loading;

    return () => {
        // Data fetching
        if (!called) {
            getUASUserActivity();
        }

        return {
            completed,
            data,
            loading,
        };
    };
};

export default useUserActivityData;
